import { GPSisOff } from '@UI/illustrationsSvg/GPSisOff.tsx'
import { Body_16_Coral_Primary_Regular_16, Title_20_Coral_Strong_emphasis_20 } from '@UI/typography/generated/typography.tsx'
import { Modal } from '@src/CommonComponents/Modal/Modal.tsx'
import { PageWithPicture } from '@src/CommonComponents/PageWithPicture/PageWithPicture.tsx'
import { Stack } from '@src/CommonComponents/Stack/Stack.tsx'
import { useGpsStore } from '@src/Store/gpsStore.ts'
import { Gt } from '@src/i18n/Gt.tsx'
import { BrowserTypes, getBrowserName, isAndroid, isIOS } from '@src/utils/getBrowser.ts'
import { useMemo } from 'react'
import styles from './gpsModals.module.less'

function getInstructionSteps(): string[] {
    if (isIOS()) {
        return ['iosStep1', 'iosStep2', 'iosStep3', 'iosStep4']
    }
    if (isAndroid()) {
        switch (getBrowserName()) {
            case BrowserTypes.Edge:
                return ['androidEdgeStep1', 'androidEdgeStep2', 'androidEdgeStep3', 'androidEdgeStep4']
            case BrowserTypes.Chrome:
                return ['androidChromeStep1', 'androidChromeStep2', 'androidChromeStep3', 'androidChromeStep4']
            default:
                return ['androidFfxStep1', 'androidFfxStep2', 'androidFfxStep3', 'androidFfxStep4']
        }
    }
    switch (getBrowserName()) {
        case BrowserTypes.Chrome:
            return ['desktopChromeStep1', 'desktopChromeStep2', 'desktopChromeStep3', 'desktopChromeStep4']
        case BrowserTypes.Safari:
            return ['desktopSafariStep1', 'desktopSafariStep2', 'desktopSafariStep3', 'desktopSafariStep4']
        case BrowserTypes.Edge:
            return ['desktopEdgeStep1', 'desktopEdgeStep2', 'desktopEdgeStep3', 'desktopEdgeStep4']
        default:
            return ['desktopFfxStep1', 'desktopFfxStep2', 'desktopFfxStep3', 'desktopFfxStep4']
    }
}

export const GpsInstructionsModals = () => {
    const setShowInstructions = useGpsStore(x => x.setShowInstructions)
    const steps = useMemo(() => getInstructionSteps(), [])

    return (
        <Modal onClose={() => setShowInstructions(false)} maxWidth={320}>
            <div style={{ padding: '24px' }}>
                <PageWithPicture>
                    <GPSisOff />
                    <Stack direction={'column'}>
                        <Title_20_Coral_Strong_emphasis_20>
                            <Gt>To clock in, please enable location services.</Gt>
                        </Title_20_Coral_Strong_emphasis_20>
                        <Stack direction={'column'} className={styles.instruction}>
                            <ol className={styles.instructionList}>
                                {steps.map(step => (
                                    <li key={step}>
                                        <Body_16_Coral_Primary_Regular_16>
                                            <Gt prefix={'GpsInstructions'}>{step}</Gt>
                                        </Body_16_Coral_Primary_Regular_16>
                                    </li>
                                ))}
                            </ol>
                        </Stack>
                    </Stack>
                </PageWithPicture>
            </div>
        </Modal>
    )
}
